import { ISubscriptionsState } from '@/@types'

const state: ISubscriptionsState = {
  recurlyToken: '',
  recurlyTokenActionId: '',
  recurlyTokenActionResult: '',
  paymentMethod: 'card',
  paymentEntries: {
    country: '',
    firstName: '',
    lastName: '',
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    company: '',
    last4DigitsOfCreditCard: '',
    creditCardVendor: '',
  },
  couponInformation: {},
  checkoutDiscount: '0',
  checkoutTaxes: '0',
  checkoutTotal: '0',
  isIn3dsFlow: false,
  isInPartnerFlow: false,
  promotionalField: '',
  paymentMethodOnFile: '',
  usersCurrentSubscriptions: [],
  userHasSkillDive: false,
}

export default state
